export function getMethod<T, Method extends keyof T>(getObj: () => T, method: Method): T[Method] {
  const fn = (...args: any[]) => {
    const obj = getObj();
    return (obj[method] as unknown as Function).call(obj, ...args);
  };
  return fn as any;
}
